module.exports = __webpack_public_path__ + "static/media/dish_20240820.e347b76f.jpg";